export function AssertNotNull<T>(instance: T | undefined | null): T {
    if (instance == null) {
        throw new Error(`Instance is ${instance === null ? "null" : "undefined"}`);
    }

    return instance;
};

export function cast<T>(instance: any, ctor: { new(...args: any[]): T }): T {
    if (instance instanceof ctor) {
        return instance;
    }
    throw new Error(`Invalid cast, expected ${ctor}, but got ${instance == null ? typeof instance : instance.constructor}.`);
};
export function castOrNull<T>(instance: any, ctor: { new(...args: any[]): T }): T | null {
    return instance instanceof ctor ? instance : null;
};
export function ancestorsOrSelf(target: Element): Element[] {
    const retval = [target];
    for (let parent = target.parentElement; parent; parent = parent.parentElement) {
        retval.push(parent);
    }
    return retval;
}

export function selectElementContent(el: HTMLElement) {
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection()!;
    sel.removeAllRanges();
    sel.addRange(range);
};

const devNull = (..._ignore: any) => { };
export const ConditionalLog = {
    log: devNull,
    set enabled(val: boolean) {
        // actually replace method not just check some bool so that "stack traces" in browser console start at the right place
        ConditionalLog.log = val ? console.log : devNull;
    },
    get enabled(): boolean {
        return ConditionalLog.log === console.log;
    },
};
